import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../Urls";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { prepareTypography } from "../ReviewParser";
import {
    MpaaQuestionText,
    AdviceGivenQuestionText,
    MoneyPurchaseAnnualAllowanceSourceArrayMap,
} from "../../Resource/Contents";
import { StringHelper } from "../../../../../../../react-core/Helpers/StringHelper";
export interface FinancialAdviceReviewProps {
    data: any;
    disableEdit?: boolean;
}
export class FinancialAdviceReview extends FormComponent<FinancialAdviceReviewProps, null> {
    public render(): JSX.Element {
        return (
            <>
                <div className="d-flex flex-space">
                    <h2 className="mb-11 text-size-21">Financial advice</h2>
                    <button
                        className="edit-circle-icon-button label-sr-only"
                        title="Edit"
                        onClick={
                            this.props.disableEdit
                                ? null
                                : () => Navigator.navigateToAndPreserveQueryParameters(this.paymentsInUrlConfig())
                        }
                    >
                        <span className="icon" aria-hidden="true"></span>
                        <span className="text">Edit financial advice</span>
                    </button>
                </div>
                <div className="flex-wrap">
                    <Typography {...prepareTypography(this.singlePaymentConfig(), 1, "narrow")}></Typography>
                </div>
            </>
        );
    }

    private paymentsInUrlConfig = () => {
        return Urls.get().SPTPaymentsIn;
    };

    private singlePaymentConfig = () => {
        const { data } = this.props;
        const configs = [];

        configs.push({ title: AdviceGivenQuestionText, data: StringHelper.ConvertBooleanToString(data?.AdviceGiven) });

        if (data?.MoneyPurchaseAnnualAllowance != null) {
            const value =
                data?.MoneyPurchaseAnnualAllowance?.Triggered != null
                    ? StringHelper.ConvertBooleanToString(data?.MoneyPurchaseAnnualAllowance?.Triggered)
                    : "Unknown";
            configs.push({
                title: MpaaQuestionText,
                data: value,
            });
            if (data?.MoneyPurchaseAnnualAllowance?.Triggered == true) {
                configs.push({
                    title: "Effective date",
                    data: JsonDateParser.getFormatDate(data?.MoneyPurchaseAnnualAllowance?.DateTriggered, "dd-MM-yyyy"),
                });
                configs.push({
                    title: "Reason why",
                    data: MoneyPurchaseAnnualAllowanceSourceArrayMap[data?.MoneyPurchaseAnnualAllowance?.Source],
                });
            }
        }
        return configs;
    };
}
